import BaseApi from '@/api/Base/BaseApi'
import {
  CreateRoiNodePayload,
  GetRoiNodeItemsPayload,
  GetRoiNodeItemsResponse,
  RoiNodeInfo,
  UpdateRoiNodePayload,
  ValidateIntersectionPayload
} from '@/api/RoiNode/types'

const ROOT = '/roi'

export default class RoiNodeApi extends BaseApi {
  createRoiNode(payload: CreateRoiNodePayload) {
    const { projectId, ...rest } = payload
    return this.agent.post<RoiNodeInfo>(`/project/${projectId}${ROOT}/create`, rest)
  }

  getRoiNodeDetail(roiNodeId: string) {
    return this.agent.get<RoiNodeInfo>(`${ROOT}/${roiNodeId}`)
  }

  updateRoiNode(payload: UpdateRoiNodePayload) {
    const { roiNodeId, name, ...rest } = payload
    return this.agent.put<RoiNodeInfo>(`${ROOT}/${roiNodeId}`, { ...rest, name: name?.trim() })
  }

  validateIntersection(payload: ValidateIntersectionPayload) {
    const { roiNodeId, ...rest } = payload
    return this.agent.post<{ hasIntersection: boolean, fileName: string, itemId: string }>(`${ROOT}/${roiNodeId}/validate-intersection`, rest)
  }

  deleteRoiNode(roiNodeId: string) {
    return this.agent.delete(`${ROOT}/${roiNodeId}`)
  }

  getRoiNodeItems(payload: GetRoiNodeItemsPayload) {
    const {
      roiNodeId,
      itemsPerPage,
      page,
      sortDir,
      sortKey,
      keyword,
    } = payload
    return this.agent.get<GetRoiNodeItemsResponse>(`${ROOT}/${roiNodeId}/items`, {
      params: {
        page,
        num_per_page: itemsPerPage ?? 20,
        sort_key: sortKey,
        sort_dir: sortDir,
        search: keyword,
      },
    })
  }
}
